import React from 'react';
import BEM from '../bem';
import TigerConnectLogo from '../images/tigerconnect-logo.png';
import { actions, useAppDispatch, useAppSelector } from 'redux-stores';

const { setTigerAgentPaneOpen } = actions;

const classes = BEM.with('TigerAgentButton');

export default function TigerAgentButton() {
  const dispatch = useAppDispatch();
  const tigerAgentPaneOpen = useAppSelector((state) => state.ui.tigerAgentPaneOpen);

  return (
    <button
      className={classes()}
      data-test-id="tiger-agent-button"
      onClick={() => dispatch(setTigerAgentPaneOpen(!tigerAgentPaneOpen))}
      type="button"
    >
      <img src={TigerConnectLogo} alt="" className={classes('icon')} />
      <span>Ask Tiger</span>
    </button>
  );
}
